import React, { useEffect, useState } from 'react'
import AddLayout from '../../../../component/AddLayout'
import { Autocomplete, Box, Button, FormControl, MenuItem, OutlinedInput, Select, TextField } from '@mui/material'
import dayjs from 'dayjs'
import DatePicker from '../../../../component/DatePicker'
import { addRawSeed, getMaterialsList, getMaterialsRawList, getRawItemMasterList, getZones } from '../../services/api'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { GetBreedClassNo, GetSeasonNo } from '../../../stock/services/stockService'
import ConfirmDialog from '../component/ConfirmDialog'
import RequireField from '../../../../component/RequireField'

export default function RepurchaseAdd() {
  const { profile } = useSelector(state => state.profile)

  const navigate = useNavigate();
  const location = useLocation()
  const [refNoError] = useState(false)
  const [senderOrReceiverError, setSenderOrReceiverError] = useState(false)
  const [senderOrReceiver, setSenderOrReceiver] = useState('')
  const [source, setSource] = useState('')
  const [documentDate, setDocumentDate] = useState(dayjs(new Date()))
  const [items, setItems] = useState([])
  const [materials, setMaterials] = useState([])
  const [branchs, setBranchs] = useState([])
  const [open, setOpen] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [documentType] = useState('รับ');
  const [seedType] = useState('ซื้อคืน');
  const [rows, setRows] = useState([
    {
      RefNo: "",
      ItemNo: null,
      Year: null,
      Lot: "",
      MaterialNo: "",
      MaterialQty: 0,
      Qty: 0,
      WarehouseNo: "",
      ZoneNo: "",
      Remark: ""
    }
  ]);
  function addRow() {
    const newRow = {
      RefNo: "",
      ItemNo: null,
      Year: null,
      Lot: "",
      MaterialNo: "",
      MaterialQty: 0,
      Qty: 0,
      WarehouseNo: "",
      ZoneNo: "",
      Remark: ""
    };

    setRows([...rows, newRow]);
  }
  const deletehand = (i) => {
    const data = rows?.filter((e, index) => i !== index);
    setRows(data);
  };


  useEffect(() => {
   if(location.state){
    setRows([
      {
        RefNo: "",
        ItemNo: location.state.ItemNo,
        Year: null,
        Lot: '',
        MaterialNo: "",
        MaterialQty: 0,
        Qty: 0,
        WarehouseNo: location.state.WarehouseNo.WarehouseNo,
        ZoneNo: location.state.ZoneNo.ZoneNo,
        Remark: ""
      }
    ])
   }
  }, [location.state])
  useEffect(() => {
    const getZonesList = async () => {
      const data = await getZones(profile?.BranchNo?.BranchNo)
      setBranchs(data)
    }
    getZonesList()
  }, [profile])

  useEffect(() => {

    const getItemMaterials = async () => {
      const data = await getRawItemMasterList()
      setItems(data)
    }

    getItemMaterials()

    


  }, [])
  useEffect(() => {
    const getMaterials = async () => {
      const data = await getMaterialsRawList()
      setMaterials(data)
    }
    getMaterials()
  }, [])

  const handleSubmit = (e) => {

    if (!senderOrReceiver) {
      setSenderOrReceiverError(true)
    }
    if (rows?.filter((x) => !x?.ItemNo)) {
      const item = rows?.map((v, index) => {
        v.LotError = v.ItemNo ? false : true
        return v;

      });
      setRows([...item]);
    }
    if (rows?.filter((x) => x?.Year?.length < 1)) {
      const item = rows?.map((v, index) => {
        v.YearError = v?.Year?.length >= 1 ? false : true
        return v;

      });
      setRows([...item]);
    }

    if (rows?.filter((x) => x?.Lot?.length < 3)) {
      const item = rows?.map((v, index) => {
        v.LotGenError = v.Lot?.length >= 3 ? false : true
        return v;

      });
      setRows([...item]);
    }
    if (rows?.filter((x) => x?.WarehouseNo?.length < 1)) {
      const item = rows?.map((v, index) => {
        v.WarehouseError = v.WarehouseNo ? false : true
        return v;

      });
      setRows([...item]);
    }
    if (senderOrReceiver && rows?.filter((x) => !x?.ItemNo).length === 0 && rows?.filter((x) => x?.Year?.length < 1).length === 0 && rows?.filter((x) => x?.Lot?.length < 3).length === 0 && rows?.filter((x) => x?.WarehouseNo?.length < 1).length === 0) {
      setOpen(true)
    }
  }
  const handleAdd = () => {
    setLoadingSubmit(true)

    const body = {
      DocumentDate: dayjs(documentDate).format('YYYY-MM-DD'),
      DocumentType: documentType,
      BranchNo: profile?.BranchNo?.BranchNo,
      SenderOrReceiver: senderOrReceiver,
      Source: source,
      SeedCategory: seedType,
      Status: "Y",
      Details: rows?.map((x) => (
        {

          RefNo: x?.RefNo,
          ItemNo: x?.ItemNo?.ItemNo,
          Year: x?.Year,
          Lot: x?.Lot,
          // Lot: x?.LotGen + x?.Lot,
          MaterialNo: x?.MaterialNo,
          MaterialQty: +x?.MaterialQty.toString().replaceAll(',', ''),
          Qty: +x?.Qty.toString().replaceAll(',', ''),
          WarehouseNo: x?.WarehouseNo,
          ZoneNo: x?.ZoneNo,
          Remark: x?.Remark
        }
      ))
    }
    const post = async () => {
      const res = await addRawSeed(body)
      if (res) {
        setLoadingSubmit(false)
        setOpen(false)
        navigate('/raw/repurchase/' + res.DocumentNo, { state: { new: true } })
      }
    }
    post()
  }
  const getLastLot = async (prefix) => {

    let _params = '';

    if (prefix) {
      _params = '?prefix=' + prefix;
    }
    // await getData(STOCK_CONFIG.requests.getLastLot.url + _params).then((response) => {
    //     if (response.status === true) {
    //         setLastLot(response.result)
    //     }
    // })
  }
  const inputHead = [
    {
      name: 'วันที่ทำรายการ',
      inputComponent: <><DatePicker value={documentDate} onChange={e => setDocumentDate(e)} disabled={false} /></>,
    },
    {
      name: '',
      inputComponent: <></>,
    },
    {
      name: 'รับจาก',
      inputComponent: <>
        <Box className={`backgroundField ${senderOrReceiverError ? 'error' : ''}`} >
                <TextField value={senderOrReceiver} onChange={e => setSenderOrReceiver(e.target.value)} variant="standard" fullWidth
                    onBlur={e => {
                        if (!e.target.value) {
                          setSenderOrReceiverError(true)
                        } else {
                          setSenderOrReceiverError(false)
                        }
                    }}
                    InputProps={{
                        disableUnderline: true,
                        // readOnly: true
                    }}
                    disabled={false}
                    placeholder='กลุ่มเกษตรกร / ชื่อเกษตรกร'
                />
            </Box>
            {senderOrReceiverError && <span style={{ color: 'red', fontSize: '12px', }}>{'กรุณากรอกที่รับ'}</span>}
      </>,
    },
    {
      name: 'สถานที่มา',
      inputComponent: <>
        <Box className={`backgroundField ${refNoError ? 'error' : ''}`} sx={{ marginBottom: '10px' }}>
          <TextField value={source}
            //  onBlur={e => {
            //     if (!e.target.value) {
            //         setRefNoError(true)
            //     } else {
            //         setRefNoError(false)
            //     }
            // }} 
            placeholder='ที่อยู่'
            onChange={e => setSource(e.target.value)} variant="standard" fullWidth
            InputProps={{
              disableUnderline: true,
            }}
          />
        </Box>
        {/* <RequireField value={senderOrReceiver} onChange={setSenderOrReceiver} type={'text'} disabled={false} error={refNoError} setError={setRefNoError} textError={'กรุณาที่รับ'} /> */}
      </>,
    },

  ]
  const head = [
    'เลขที่อ้างอิง',
    'เมล็ดพันธุ์',
    'ชั้นพันธุ์',
    'ฤดู',
    'ปีที่ผลิต',
    'ล็อตที่',
    'ประเภทบรรจุภัณฑ์',
    'จำนวน (กระสอบ)',
    'ปริมาณ (กิโลกรัม)',
    'ปริมาณเฉลี่ย/กระสอบ',
    'โรงเก็บที่',
    'หมายเหตุ',
    ''
  ]
  const body = rows?.map((x, i) => {

    return {
      item1: <TextField value={x?.RefNo || ''}
        sx={{ background: '#fff', width: '150px' }}
        size='small' fullWidth variant='outlined'
        onChange={e => {
          const item = rows?.map((v, index) => {
            v.RefNo = index === i ? e.target.value : v?.RefNo;
            return v;

          });
          setRows(item);
        }}
      />,
      item2: <>
        <Autocomplete
          size='small'
          options={items}
          getOptionLabel={(option) => option?.ItemName}
          onBlur={e => {
            const item = rows?.map((v, index) => {
              v.LotError = index === i ? x.ItemNo ? false : true : v?.LotError;
              return v;
            });
            setRows([...item]);
          }
          }
          componentsProps={{
            paper: {
              sx: {
                width: 500
              }
            }
          }}
          renderOption={(props, option) => (
            <Box component="li" {...props} key={option.ItemNo}>
              {option?.CatalogNo?.CatalogName} {option?.Option2} <span style={{ color: option?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{option?.Season}</span> {option?.Option1}
            </Box>
          )}
          value={x?.ItemNo}
          onChange={(event, newValue) => {
            const item = rows?.map((v, index) => {
              v.LotGen = index === i ? '' : v?.LotGen;
              v.ItemNo = index === i ? newValue : v?.ItemNo;
              return v;

            });
            setRows([...item]);

          }}

          renderInput={(params) => (
            <Box ref={params.InputProps.ref}>
              <OutlinedInput error={!x?.LotError ? false : true} {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important', background: '#fff' }} />
            </Box>
          )}
        />
        {!x?.LotError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', left: '10px' }}>กรุณาเลือกเมล็ดพันธุ์</span>}</>,
      item3: x?.ItemNo?.Option2,
      item4: <span style={{ color: x?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold' }}>{x?.ItemNo?.Season}</span>,
      item5: <><TextField className='w-70' error={!x?.YearError ? false : true} onBlur={e => {
        const item = rows?.map((v, index) => {
          v.YearError = index === i ? x.Year ? false : true : v?.YearError;
          return v;

        });
        setRows([...item]);
      }
      } value={x?.Year}
        size='small' variant='outlined' onChange={e => {
          const branchNo = profile?.BranchNo?.BranchNo
          const breedClassNo = GetBreedClassNo(x?.ItemNo?.Option2)
          const seasonNo = GetSeasonNo(x?.ItemNo?.Season)
          // const lotNumber = branchNo + breedClassNo + seasonNo + e.target.value;
          const item = rows?.map((v, index) => {
            v.Year = index === i ? e.target.value : v?.Year;
            // v.LotGen = index === i ? lotNumber : v?.LotGen
            return v;

          });
          setRows([...item]);
          getLastLot(x?.LotGen)
        }}
        sx={{ background: '#fff' }}
        inputProps={{ maxLength: 2 }}
        onKeyPress={(event) => {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        }} />
        {!x?.YearError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-8px', left: "8px" }}>กรุณากรอกปี</span>}
      </>,
      item6: <div style={{ position: "relative" }}>
        <Box sx={{
          display: 'flex', '& .MuiTextField-root': {
            color: 'red',
            '& .MuiOutlinedInput-root': { borderRadius: '0 .25rem .25rem 0' }
          }
        }}>
          {/* <div style={{
            display: 'flex',
            alignItems: 'center',
            padding: '.375rem .75rem',
            fontSize: '1rem',
            fontWeight: '400',
            lineHeight: '1.5',
            color: '#212529',
            textAlign: 'center',
            whiteApace: 'nowrap',
            backgroundColor: '#e9ecef',
            border: '1px solid #ced4da',
            borderRadius: '.25rem 0 0 .25rem',

          }}>{x?.LotGen}</div> */}
          <TextField sx={{ width: '120px' }} error={!x?.LotGenError ? false : true}
            onBlur={e => {
              const item = rows?.map((v, index) => {
                v.LotGenError = index === i ? x.Lot.length === 3 ? false : true : v?.LotGenError;
                return v;

              });
              setRows([...item]);
            }} value={x?.Lot}
            inputProps={{ maxLength: 6 }}
            size='small' fullWidth variant='outlined' onChange={e => {
              const item = rows?.map((v, index) => {
                v.Lot = index === i ? e.target.value : v?.Lot;
                return v;

              });
              setRows([...item]);
            }} 
            // onKeyPress={(event) => {
            //   if (!/[0-9]/.test(event.key)) {
            //     event.preventDefault();
            //   }
            // }} 
            />

        </Box>
        {/* {!x?.LotGenError || lastLot ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-16px' }}>กรุณากรอกเลขล็อต</span>} 
  {lastLot && <span style={{ fontSize: '12px', position: 'absolute', bottom: '-20px' }}>{`Lotล่าสุด  ${lastLot}`}</span>}
   */}
      </div>,
      item7: <FormControl className='w-120' variant="outlined" size='small' fullWidth
        error={x?.MaterialNoError}
      >
        <Select value={x?.MaterialNo} onChange={e => {
          const item = rows?.map((v, index) => {
            v.MaterialNo = i === index ? e.target.value : v?.MaterialNo;
            v.MaterialName = i === index ? materials?.find((x) => x?.ItemNo === e.target.value)?.ItemName : v?.MaterialName

            return v;

          });
          setRows([...item]);
        }} onBlur={e => {
          const item = rows?.map((v, index) => {
            v.MaterialNoError = index === i ? x.MaterialNo ? false : true : v?.MaterialNoError;
            return v;

          });
          setRows([...item]);
        }} >
          {materials?.map((z, i) => {
            return (
              <MenuItem key={i} value={z?.ItemNo}>{z?.ItemName}</MenuItem>
            )
          })}
        </Select>
      </FormControl>,
      item8: <TextField value={x?.MaterialQty.toLocaleString()}
        sx={{ background: '#fff', width: '120px' }}
        type='tel' size='small' fullWidth variant='outlined' onChange={e => {
          let newValue = e.target.value.replace(/,/g, "");

          let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          const item = rows?.map((v, index) => {
            v.MaterialQty = i === index ? abc : v?.MaterialQty;
            v.OtyPer = i === index ? +x?.Qty?.toString().replaceAll(',', '') / +e.target.value.toString().replaceAll(',', '') : v?.OtyPer
            return v;

          });
          setRows([...item]);
        }} onKeyPress={(event) => {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        }} />,
      item9: <TextField value={x?.Qty.toLocaleString()}
        sx={{ background: '#fff', width: '120px' }}
        type='tel' size='small' fullWidth variant='outlined' onChange={e => {
          let newValue = e.target.value.replace(/,/g, "");

          let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          const item = rows?.map((v, index) => {
            v.OtyPer = i === index ? +e.target.value.toString().replaceAll(',', '') / +x?.MaterialQty.toString().replaceAll(',', '') : v?.OtyPer
            v.Qty = i === index ? abc : v?.Qty;
            return v;

          });
          setRows([...item]);
        }} onKeyPress={(event) => {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        }} />,
      item10: x?.OtyPer?.toFixed(2),
      item11: <> <FormControl className='w-120' variant="outlined" size='small' fullWidth
        error={x?.WarehouseError}
      >
        <Select value={x?.ZoneNo} onChange={e => {
          const item = rows?.map((v, index) => {
            v.WarehouseNo = i === index ? branchs?.find((x) => x?.ZoneNo === e.target.value)?.WarehouseNo.WarehouseNo : v?.WarehouseNo;
            v.ZoneNo = i === index ? branchs?.find((x) => x?.ZoneNo === e.target.value).ZoneNo : v?.ZoneNo
            v.WarehouseName = i === index ? branchs?.find((x) => x?.ZoneNo === e.target.value)?.WarehouseNo.WarehouseName : v?.WarehouseName
            v.ZoneName = i === index ? branchs?.find((x) => x?.ZoneNo === e.target.value).ZoneName : v?.ZoneName
            return v;

          });
          setRows([...item]);
        }} onBlur={e => {
          const item = rows?.map((v, index) => {
            v.WarehouseError = index === i ? x.WarehouseNo ? false : true : v?.WarehouseError;
            return v;

          });
          setRows([...item]);
        }} >
          {/* <MenuItem value='all' disabled>เลือกโรงเก็บ</MenuItem> */}
          {branchs?.map((z, i) => (
            <MenuItem value={z?.ZoneNo}>{z?.WarehouseNo?.WarehouseName} {z?.ZoneName}</MenuItem>
          ))}
        </Select>
      </FormControl>
        {!x?.WarehouseError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-6px', left: "8px" }}>กรุณาเลือกโรงเก็บ</span>}
      </>,
      item12: <TextField sx={{ width: '150px' }} value={x?.Remark} size='small' fullWidth variant='outlined' onChange={e => {

        const item = rows?.map((v, index) => {
          v.Remark = i === index ? e.target.value : v?.Remark;
          return v;

        });
        setRows([...item]);
      }}
      />,
      item13: <FontAwesomeIcon icon={faMinusCircle} onClick={() => deletehand(i)} />,
    }
  })
  return (
    <AddLayout
      title={'เพิ่มรายการรับเมล็ดพันธ์ุดิบ'}
      inputHead={inputHead}
      inputRemark={null}
      bodyTitle={'รายการรับเมล็ดพันธ์ุดิบ'}
      bodyAction={<FontAwesomeIcon icon={faPlusCircle} onClick={addRow} />}
      tableHead={head}
      tableBody={body}
      bootomAction={<>
        <Button onClick={() => navigate(-1)} variant='outlined'
          startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
          sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
        <Button variant='contained' onClick={() => handleSubmit()} sx={{ width: '130px', fontSize: '14px' }}>บันทึก</Button></>}
      dialog={<ConfirmDialog open={open} setOpen={setOpen} rows={rows} handleSubmit={handleAdd} loadingSubmit={loadingSubmit} />} />
  )
}
